import MobileCarousel from '../../src/js/mobile-carousel';

export default class ProductImageGallery {
  constructor() {
    this.$els = document.querySelectorAll('.js-product-image-gallery');
    this.activeClass = 'is-active';

    this.$els.forEach($el => {
      const $buttons = $el.querySelectorAll('.js-product-image-gallery-button');
      const $images = $el.querySelectorAll('.js-product-image-gallery-image');
      const $carousel = $el.querySelector('.js-product-image-gallery-carousel');

      const mobileCarousel = new MobileCarousel($carousel, {
        maxWidth: 768,
      });

      if (mobileCarousel.carousel) {
        mobileCarousel.carousel.on('select', (index) => {
          $buttons.forEach($button => $button.classList.remove(this.activeClass));
          $buttons[index].classList.add(this.activeClass);
          // $buttons[index].scrollIntoView({
          //   behavior: 'smooth',
          //   block: 'nearest',
          //   inline: 'center',
          // });
        });
      }

      const clickHandler = ($button, index) => {
        $buttons.forEach($button => $button.classList.remove(this.activeClass));
        $images.forEach($image => $image.classList.remove(this.activeClass));

        $button.classList.add(this.activeClass);
        $images[index].classList.add(this.activeClass);

        if(mobileCarousel.carousel) {
          mobileCarousel.carousel.select(index);
        }
      };

      $buttons.forEach(($button, index) => {
        $button.addEventListener('click', () => clickHandler($button, index));
      });
    });
  }
}
